import { Button, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="Using Title" />
			<Text semiBold text="Using TooltipProps" />
			<Text semiBold text="Using localized text" />
			<Button design="default" title="Tooltip Text">Button</Button>
			<Button design="primary" tooltipProps={{ title: "Tooltip Text", placement: "top" }}>Button</Button>
			<Button design="secondary" tooltipProps={{ res: "Default", placement: "bottom" }}>Button</Button>
		</CssColumnGrid>
	);
};